import React from 'react';
import { motion } from 'framer-motion';
import { BatteryWarning, Flame, Activity } from 'lucide-react';
export function ProblemSection() {
  return <section className="py-20 px-4 sm:px-6 lg:px-8 bg-[#FDFAF6]" data-id="element-131">
      <div className="max-w-4xl mx-auto" data-id="element-132">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.6
      }} className="text-center mb-16" data-id="element-133">
          <h2 className="text-3xl md:text-4xl font-bold text-[#1A1A1A] mb-8 leading-tight" data-id="element-134">
            ¿Te levantas cansada aunque hayas dormido 8 horas?
          </h2>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mt-12" data-id="element-135">
            <div className="flex flex-col items-center text-center p-6 rounded-2xl bg-white shadow-sm border border-[#F0FDF4]" data-id="element-136">
              <div className="w-12 h-12 rounded-full bg-[#F59E0B]/10 flex items-center justify-center mb-4 text-[#F59E0B]" data-id="element-137">
                <BatteryWarning size={24} data-id="element-138" />
              </div>
              <p className="text-gray-700 font-medium" data-id="element-139">
                Tu energía se agota justo cuando más la necesitas
              </p>
            </div>

            <div className="flex flex-col items-center text-center p-6 rounded-2xl bg-white shadow-sm border border-[#F0FDF4]" data-id="element-140">
              <div className="w-12 h-12 rounded-full bg-[#2D8C4E]/10 flex items-center justify-center mb-4 text-[#2D8C4E]" data-id="element-141">
                <Activity size={24} data-id="element-142" />
              </div>
              <p className="text-gray-700 font-medium" data-id="element-143">
                Sientes inflamación abdominal que no desaparece
              </p>
            </div>

            <div className="flex flex-col items-center text-center p-6 rounded-2xl bg-white shadow-sm border border-[#F0FDF4]" data-id="element-144">
              <div className="w-12 h-12 rounded-full bg-[#F59E0B]/10 flex items-center justify-center mb-4 text-[#F59E0B]" data-id="element-145">
                <Flame size={24} data-id="element-146" />
              </div>
              <p className="text-gray-700 font-medium" data-id="element-147">
                Sientes que tu cuerpo ya no responde como antes
              </p>
            </div>
          </div>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6,
        delay: 0.2
      }} className="bg-[#F0FDF4] rounded-3xl p-8 md:p-12 text-center relative overflow-hidden" data-id="element-148">
          <div className="absolute top-0 right-0 w-32 h-32 bg-[#2D8C4E] opacity-5 rounded-bl-full pointer-events-none" data-id="element-149"></div>

          <h3 className="text-2xl md:text-3xl font-bold text-[#2D8C4E] mb-6" data-id="element-150">
            Tu metabolismo ha entrado en modo reserva.
          </h3>
          <p className="text-xl text-[#1A1A1A] font-medium mb-8" data-id="element-151">
            Hoy sabrás cómo reactivarlo en solo 12 días.
          </p>

          <div className="text-left space-y-4 text-gray-700 max-w-2xl mx-auto font-sans" data-id="element-152">
            <p data-id="element-153">
              <strong data-id="element-154">Las dietas restrictivas</strong> frenan la quema de grasa.
            </p>
            <p data-id="element-155">
              <strong data-id="element-156">Los entrenamientos largos</strong> elevan el cortisol.
            </p>
            <p data-id="element-157">
              Y las soluciones rápidas no atacan la raíz del metabolismo lento.
            </p>
            <p className="text-lg font-medium text-[#1A1A1A] pt-4 border-t border-[#2D8C4E]/20 mt-6" data-id="element-158">
              Tu cuerpo no está roto, solo espera las señales correctas.
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}